import request from '@/utils/request'

// 获取订单列表
export function getOrderList(params) {
    return request({
        url: '/agent/order/list',
        method: 'get',
        params,
    })
}

// 获取订单列表
export function getOrderDetail(orderSn) {
    return request({
        url: `/agent/order/find-detail/${orderSn}`,
        method: 'get',
    })
}

// 结束订单
export function closeOrderApi(data) {
    return request({
        url: `/agent/order/closeOrder/${data.orderSn}`,
        method: 'post',
        data
    })
}

// 获取订单详情的分润列表
export function getProfitList(orderSn) {
    return request({
        url: `/agent/accountRecord/order/profit/${orderSn}`,
        method: 'get',
    })
}



// WEBPACK FOOTER //
// ./src/api/order.js